import { deleteArticulo, getArticulosPanel, getArticulosExistenciaPanel } from "../../services/ArticulosServices";
import { getArtNoCombosPanel } from "../../services/ArticulosCombosServices";
import { ArticulosContext } from "./ArticulosContext"

export const ArticulosState = ({ children }) => {
    const getArticulosPanelData = async (searchTerm, searchRam, searchRub, searchSubr, searchMar, searchDes, page, perPage) => {
        let res = await getArticulosPanel(searchTerm, searchRam, searchRub, searchSubr, searchMar, searchDes, page, perPage)
        return res;
    }
    const getArtNoCombosPanelData = async (searchTerm, searchRam, searchRub, searchSubr, searchMar, searchDes, page, perPage) => {
        let res = await getArtNoCombosPanel(searchTerm, searchRam, searchRub, searchSubr, searchMar, searchDes, page, perPage)
        return res;
    }
    const getArticulosExistenciaPanelData = async (searchTerm, searchRam, searchRub, searchSubr, searchMar, searchDes, searchStock, page, perPage, selectOrderBy, selectOrder) => {
        let res = await getArticulosExistenciaPanel(searchTerm, searchRam, searchRub, searchSubr, searchMar, searchDes, searchStock, page, perPage, selectOrderBy, selectOrder)
        return res;
    }
    const deleteArticuloData = async (body) => {
        const res = await deleteArticulo(body)
        return res
    }

    return <ArticulosContext.Provider value={{
        deleteArticuloData,
        getArticulosPanelData,
        getArtNoCombosPanelData,
        getArticulosExistenciaPanelData
    }} >
        {children}
    </ArticulosContext.Provider>
}